// extracted by mini-css-extract-plugin
export default {"main":"Option_main__wxLdL","text":"Option_text__Ufq5F","main_focused":"Option_main_focused__lufxR","input":"Option_input__rCoUN","save_btn":"Option_save_btn__ZWRcD"};